<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeFilter" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <div class="row align-items-end pt-2">
              <filter-component
                @filter="handleFilter"
                @onChangeFilters="handleFilterChange"
                @showHideLoading="showHideLoading"
                :filterOfZones="true"
                :filterOfSubZones="true"
                :filterOfLots="false"
                :classFarms="`col-12 col-md-6 col-lg-4 col-xl-4`"
                :classZones="`col-12 col-md-6 col-lg-4 col-xl-4`"
                :classSubZones="`col-12 col-md-6 col-lg-4 col-xl-4`"
                :isRequiredZones="true"
                :isRequiredSubZones="true"
                :isRequiredFarms="true"
              ></filter-component>
            </div>
          </el-collapse-item>
        </el-collapse>
      </card>
      <div v-if="isIndex()">
        <div
          v-if="hasData"
          class="row mx-1 d-flex flex-wrap justify-content-between align-items-center"
        >
          <div
            v-for="(chart, index) in columnChart"
            :key="index"
            :class="cardClass(index)"
          >
            <card class="w-100">
              <div class="row">
                <div class="col-12">
                  <highcharts :options="chart" />
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
      <div v-if="isIndex()">
        <div v-if="hasData">
          <card
            class="custom-shadow-card-header"
            :title="$t('sigatoka.sigatoka_ranking_report')"
          >
            <el-collapse v-model="activeFarms" @change="handleCollapse">
              <el-collapse-item
                v-for="farm in farms"
                :key="farm"
                :title="farm"
                :name="farm"
              >
                <div class="row w-100 pl-3">
                  <div class="custom-scroll-table-wrapper w-100">
                    <table
                      class="table table-striped table-bordered mt-3 w-100"
                    >
                      <thead>
                        <tr class="cusmtom-thead-color">
                          <th
                            rowspan="2"
                            style="min-width: 85px"
                            class="text-center p-3 custom-header-label sticky-header"
                          >
                            {{ $t('common_words.date') }}
                          </th>
                          <th
                            v-for="age in agesByFarm(farm)"
                            style="min-width: 85px"
                            :colspan="agesColspan(age)"
                            class="text-center p-3 custom-header-label sticky-header"
                          >
                            {{
                              age === 0
                                ? $t('sigatoka.expecting')
                                : age === 1
                                ? $t('sigatoka.newly_given_birth')
                                : age + ' ' + $t('common_words.weeks')
                            }}
                          </th>
                          <th
                            v-if="table[farm][0].youngPlants"
                            style="min-width: 85px"
                            :colspan="youngColspan(farm)"
                            class="text-center p-3 custom-header-label sticky-header"
                          >
                            {{ $t('sigatoka.young_plants') }}
                          </th>
                        </tr>
                        <tr class="cusmtom-thead-color">
                          <template v-for="age in agesByFarm(farm)">
                            <th
                              v-for="metric in agesMetrics(age)"
                              :key="age + '-' + metric"
                              style="min-width: 85px"
                              class="text-center p-3 custom-header-label sticky-header"
                            >
                              {{ metric.toUpperCase() }}
                            </th>
                          </template>
                          <th
                            v-if="table[farm][0].youngPlants"
                            class="text-center p-3 custom-header-label sticky-header"
                            style="min-width: 85px"
                          >
                            {{ $t('sigatoka.total_functional_leaves') }}
                          </th>
                          <th
                            v-if="table[farm][0].youngPlants"
                            class="text-center p-3 custom-header-label sticky-header"
                            style="min-width: 85px"
                          >
                            {{ $t('sigatoka.ref') }}
                          </th>
                          <th
                            v-if="table[farm][0].youngPlants"
                            v-for="leaf in youngData(farm)"
                            :key="leaf"
                            style="min-width: 85px"
                            class="text-center p-3 custom-header-label sticky-header"
                          >
                            {{ $t('sigatoka.leaf') }} {{ leaf }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="row in rowsByFarm(farm)" :key="row.key">
                          <td class="text-center">
                            {{ row.label }}
                          </td>
                          <template v-for="cell in row.values">
                            <td class="text-center" v-if="cell.total_leaves">
                              {{ cell.total_leaves }}
                            </td>
                            <td class="text-center" v-if="cell.yls">
                              {{ cell.yls }}
                            </td>
                            <td class="text-center" v-if="cell.yli">
                              {{ cell.yli }}
                            </td>
                            <td
                              v-if="
                                table[farm][0].youngPlants &&
                                cell.functional_leaf
                              "
                              class="text-center"
                            >
                              {{ cell.functional_leaf }}
                            </td>
                            <td
                              v-if="table[farm][0].youngPlants && cell.ref"
                              class="text-center"
                            >
                              {{ cell.ref }}
                            </td>
                            <td
                              v-if="table[farm][0].youngPlants && cell.leaves"
                              v-for="leaf in cell.leaves"
                              class="text-center"
                            >
                              {{ leaf }}
                            </td>
                          </template>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
            <export-tables class="mb-3" :pdf="pdf" :xls="xls" />
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import i18n from 'src/i18n';
import { Chart } from 'highcharts-vue';
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import { getDateToday } from 'src/util/Util';
import MixinCharts from 'src/util/mixinCharts';
import MixinMasters from 'src/util/mixinMasters';
import Filter from 'src/components/Filter/Filters.vue';
import MixinPermissions from 'src/util/mixinPermissions';
import ExportTables from 'src/components/Tables/ExportTables.vue';
import MixinValidations from 'src/mixins/forms/mixin-validations.js';

export default {
  mixins: [
    MixinMenu,
    MixinCharts,
    MixinMasters,
    MixinPermissions,
    MixinValidations,
  ],
  components: {
    [ExportTables.name]: ExportTables,
    [Filter.name]: Filter,
    highcharts: Chart,
  },
  data() {
    return {
      data: {},
      table: [],
      hasData: false,
      activeFarms: [],
      columnChart: [],
      valueCollapse: null,
      activeFilter: ['filter'],
    };
  },
  computed: {
    dateToday() {
      return getDateToday();
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    farms() {
      if (!this.table || !Object.keys(this.table).length) return [];
      return Object.keys(this.table);
    },
    pdf() {
      return {
        filename: `${i18n.t('sigatoka.sigatoka_ranking_report')}_${
          this.dateToday
        }.pdf`,
        route: 'sigatoka/ranking/pdf',
        paramMethod: 'POST',
        plusData: {
          data: this.data,
        },
      };
    },
    xls() {
      return {
        filename: `${i18n.t('sigatoka.sigatoka_ranking_report')}_${
          this.dateToday
        }.xlsx`,
        route: 'sigatoka/ranking/excel',
        paramMethod: 'POST',
        plusData: {
          data: this.data,
        },
      };
    },
  },
  methods: {
    handleFilterChange() {
      this.hasData = false;
    },
    handleFilter(data) {
      this.hasData = false;
      this.dataFilter = { ...data };
      this.data = this.dataFilter;
      this.getData();
    },
    handleCollapse(val) {
      this.valueCollapse = val;
    },
    agesColspan(age) {
      return age === 0 ? 3 : 2;
    },
    agesMetrics(age) {
      return age === 0
        ? [
            i18n.t('sigatoka.total_functional_leaves'),
            i18n.t('sigatoka.yls'),
            i18n.t('sigatoka.yli'),
          ]
        : [i18n.t('sigatoka.total_functional_leaves'), i18n.t('sigatoka.yls')];
    },
    agesByFarm(farm) {
      if (!this.table[farm]) return [];
      const ages = [];
      this.table[farm].forEach((item) => {
        if (item.ages) {
          ages.push(...Object.values(item.ages));
        }
      });

      return [...new Set(ages)].sort((a, b) => a - b);
    },
    cardClass(index) {
      if (this.columnChart.length > 4) {
        if (index > 1) return 'col-12 col-md-12 col-lg-4';
        if (index === 4) return 'col-12 col-md-12 col-lg-4';
      }
      return 'col-12 col-md-12 col-lg-6';
    },
    rowsByFarm(farm) {
      if (!this.table[farm]) return [];
      return this.table[farm].map((item) => {
        return {
          key: item.date,
          label: item.date,
          values: this.rowValues(item, farm),
        };
      });
    },
    rowValues(item, farm) {
      const values = [];
      const ages = this.agesByFarm(farm);
      ages.forEach((age) => {
        const found = item.totals.find((t) => t.age === age);
        values.push({
          total_leaves: found.metrics.total_leaves,
          yls: found.metrics.yls,
          yli: found.metrics.yli,
        });
      });
      if (this.table[farm][0].youngPlants)
        values.push({
          functional_leaf: item.youngPlants.functional_leaf,
          ref: item.youngPlants.ref,
          leaves: item.youngPlants.leaves,
        });

      return values;
    },
    youngColspan(farm) {
      return Object.keys(this.table[farm][0].youngPlants.leaves).length + 2;
    },
    youngData(farm) {
      const leaf = this.table[farm][0].youngPlants.leaves;
      return Object.keys(leaf).map(Number);
    },
    async getData() {
      if (this.isIndex()) this.setData(await this.getReport());
      else this.showHideLoading();
      this.showHideLoading();
    },
    async getReport() {
      this.showHideLoading(true);
      const data = this.dataFilter;
      data.route = 'sigatoka/ranking/filterdata';
      const [responseReport] = await Promise.all([
        Axios.postMasters(data),
      ]).catch((error) => {
        this.showHideLoading();
        this.showMessageErrors(error);
      });

      return responseReport.data.data;
    },
    setData(response) {
      if (!response.table)
        SweetAlert.warning(i18n.t('common_words.unavailable_data'));
      else {
        this.table = response.table;
        this.columnChart = response.columnChart.map((chart) =>
          this.columns(chart)
        );
        this.hasData = true;
        this.$nextTick(() => {
          this.activeFarms = Object.keys(this.table);
        });
      }
      this.showHideLoading();
    },
  },
  mounted() {
    this.selectedItemOnMenu('sigatoka');
  },
};
</script>
<style scoped>
.custom-scroll-table-wrapper {
  max-height: 600px;
  overflow: auto;
}
</style>
